var exports = {
  "y": "FooterRedesignOffset__C2mKrx",
  "Q": "NavPane__8xvsOm",
};

module.exports = exports;
